export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43OTM2IDEuNDE0MjFMMjEuMzczMiA3Ljk5Mzg0TDE0Ljc5MzYgMTQuNTczNUwxNi4yMDc4IDE1Ljk4NzdMMjQuMjAxNyA3Ljk5Mzg0TDE2LjIwNzggMEwxNC43OTM2IDEuNDE0MjFaTTE3IDYuOTkzODRIMFY4Ljk5Mzg0SDE3VjYuOTkzODRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./images/arrow-long.svg
// module id = 218
// module chunks = 0